import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'translateDate'
})

//NOT USED
export class translateDatePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    console.log(window['appGlobals'].constants.userLanguage)

    const date = new Date(value); // Ensure proper parsing

    const formatter = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
    return formatter.format(date);


  }
}
